import { LoadableLazy } from '@confluence/loadable';

export { useConnectionsPanel } from '../src/ConnectionsPanel/useConnectionsPanel';
export const EditorContextConnectionsPanel = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-appreferentiality" */ '../src/ConnectionsPanel/EditorContextConnectionsPanel'
			)
		).EditorContextConnectionsPanel,
});
